export default "__VITE_ASSET__ab9fa8af__"